import classNames from "classnames";
import * as React from "react";
import { UnnamedResource } from "~/normalizr/entities";
import { RowCheckMark } from "~/sharedComponents/list/ListRowDefault";
import { AvatarSizes, SpriteAvatar } from "../avatar/SpriteAvatar";
import { VirtListRowProps } from "../list/BaseList";
import { UserName } from "../users/UserName";
import * as styles from "./UserListRow.less";

export type UnnamedResourceListProps = VirtListRowProps<Partial<UnnamedResource>> & {
    className?: string;
    isSelected?: boolean;
};

export const UnnamedResourceListRow: React.FC<UnnamedResourceListProps> = ({
    item,
    isFocused,
    isSelected,
    textForHighlight,
    className,
}) => {
    const rowStyle = classNames(className, styles.row, isFocused && [styles.focused]);

    return (
        <div className={rowStyle} title={item.Name} data-testid="unnamed_row">
            <SpriteAvatar size={AvatarSizes.Small} unnamedResourceId={item.UnnamedResourceId} />
            <div className={styles.info}>
                <UserName name={item.Name} className={styles.name} textForHighlight={textForHighlight} />
            </div>
            <RowCheckMark selected={isSelected} />
        </div>
    );
};
